import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-opra-attachment-b1',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './opra-attachment-b1.component.html',
})
export class OpraAttachmentB1Component {
  @Input({ required: true }) vendorName!: string;
  @Input({ required: true }) contactEmail!: string;
  @Input({ required: true }) selfServiceUrl!: string;
}
